// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CFwPo","loader":"styles_loader__nUrec","spin":"styles_spin__3ODrb"};